var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-link flex border items-center border-current leading-none whitespace-no-wrap",class:_vm.clss},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }